import { Field, Input, InputProps, Text } from '@chakra-ui/react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';

interface FormInputProps extends Omit<InputProps, 'name'> {
  name: string;
  label: string;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  required?: boolean;
}

const FormInput = ({
  name,
  label,
  register,
  errors,
  required = false,
  ...inputProps
}: FormInputProps) => {
  const fieldError = errors[name];
  const isInvalid = !!fieldError;

  return (
    <Field.Root invalid={isInvalid}>
      <Field.Label>
        {label}
        {required && <Text color="red.fg">*</Text>}
      </Field.Label>
      <Input {...register(name)} {...inputProps} />

      {isInvalid && <Field.ErrorText>{fieldError.message?.toString()}</Field.ErrorText>}
    </Field.Root>
  );
};

export default FormInput;
